import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Separator from '@src/components/Separator';
import { Body1, H2 } from '@src/components/Typography';
import { maxWidth, padding } from '@src/configuration/constants';
import { Business } from '@src/types';

export const List = styled(FlatList as new () => FlatList<Business>).attrs(
  () => ({
    removeClippedSubviews: true,
    scrollEventThrottle: 16,
    initialNumToRender: 16,
    maxToRenderPerBatch: 16,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingBottom: padding,
      maxWidth: maxWidth,
    },
  })
)``;

export const BusinessContainer = styled.TouchableOpacity`
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  padding: 5px ${padding}px;
`;

export const BusinessWrapper = styled.View`
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  padding-start: ${padding}px;
`;

export const BusinessName = styled(H2)`
  margin: 5px;
`;

export const BusinessAddress = styled(Body1)`
  // margin: 0 5px;
  padding-end: 5px;
  color: ${({ theme }) => theme.colors.disabled};
`;
